export default __webpack_public_path__ + "static/media/Hauora-Medium.099d02a5.woff2";